
/* injects from baggage-loader */
require('./limited.component.html');

import angular from 'angular';
import { tokenMissing$ } from '../../modules/oidc-auth/events';

import './limited.scss';
import './limited.css';

angular.module('AaApp.Opp').component('limited', {
    templateUrl: '/app/components/limited/limited.component.html',
    controller: LimitedController,
    bindings: {
        kendo: '<'
    }
});

/* @ngInject */
function LimitedController($auth, storageService) {
    const $ctrl = this;
    storageService.setItem('runAsLimited', '/limited/dashboard');

    //taking this from a comment in deal-sheet.component.js init to redirect properly when AM user was not logged in
    if (!$auth.isAuthenticated()) {
        storageService.setItem('localRedirectPath', '/limited/dashboard');
        tokenMissing$.next();
        return;
    }

    $ctrl.$onInit = init;
}

function init() {

    //hide initial elements
    hideElement(document.getElementById('aa-header-context'));
    hideElement(document.getElementById('aa-header-logo'));
    hideElement(document.getElementById('aa-header-skewcontainer'));
    hideElement(document.getElementById('aa-header-menu'));
    hideElement(document.getElementById('aa-header-customer-search'));

    hideElementsOnDelay();
}

function hideElement(el) {
    if (el) {
        el.style.display = "none";
    }
}

function hideElementsOnDelay() {
    setTimeout(function () {

        hideElement(document.getElementById('aa-footer'));

        const menuElements = document.querySelectorAll("ul li");
        if (menuElements && menuElements.length > 0) {
            for (let i = 0; i < menuElements.length; i++) {
                const menuEl = menuElements[i].querySelector("a");
                if (menuEl
                    && menuEl.text !== "Data Entry" 
                    && menuEl.text !== "Prices"
                    && menuEl.text !== "Rates"
                    && menuEl.text !== "Dealer Rebates"
                    && menuEl.text !== "Trade Ins"
                    && menuEl.text !== "Alert Tolerances"
                    && menuEl.text !== "Replacement Offers"
                    && menuEl.text !== "Admin"
                    && menuEl.text !== "Settings"
                    && menuEl.text !== "Users"
                    && menuEl.text !== "Do Not Call / Email"
                ) {
                    hideElement(menuElements[i]);
                }
            }
        }

        hideSelfHelpElements();
    }, 2000);
}
function hideSelfHelpElements() {
    setTimeout(function () {
        hideElement(document.getElementById('_wfx_unified_panel'));
        hideElement(document.getElementById('_wfx_unified_panel_root'));
        const selfHelpEl = document.getElementById('_tasker_wfx_');
        if (selfHelpEl) {
            selfHelpEl.classList.remove("WFEMFGC");
            hideElement(selfHelpEl);
        }
    }, 3000);
}
